module.exports = __webpack_public_path__ + "static/media/accidents.6c4eb84d.svg";